module.exports = __webpack_public_path__ + "img/aptech.910cab70.svg";